import { render, staticRenderFns } from "./FormulateImage.vue?vue&type=template&id=518dc382&"
import script from "./FormulateImage.vue?vue&type=script&lang=js&"
export * from "./FormulateImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('518dc382')) {
      api.createRecord('518dc382', component.options)
    } else {
      api.reload('518dc382', component.options)
    }
    module.hot.accept("./FormulateImage.vue?vue&type=template&id=518dc382&", function () {
      api.rerender('518dc382', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/formulate/image/FormulateImage.vue"
export default component.exports